window._ = require('lodash');

import axios from 'axios';
import store from "./store";
import routes from "./routes";
import {app} from "./app";

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
}

window.axios = require('axios');

axios.interceptors.request.use(config => {
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const token = store.getters['token'];
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, async error => {
    if (store.getters['token']) {
        // TODO: Find more reliable way to determine when Token state
        if (error.response.status === 401 && error.response.data.message === 'El token ha caducado.') {
            const {data} = await axios.post('/api/login/refresh');
            await store.dispatch('saveToken', data);
            return axios.request(error.config);
        }

        if (error.response.status === 401 || (error.response.status === 500 && (
            error.response.data.message === 'El token ha caducado y no se pudo actualizar.' ||
            error.response.data.message === 'El token ha sido incluido en la lista negra.'
        ))) {
            await store.dispatch('destroy');
            routes.push({name: 'Login'});
        }
    }

    error.response.data.message !== undefined && app.$bvToast.toast(error.response.data.message || 'Algo salió mal.', {
        title: 'Error',
        variant: 'danger',
        toaster: 'b-toaster-top-right',
        autoHideDelay: 5000,
        solid: true,
        appendToast: true
    });

    let errors = error.response.data.errors;
    for (let key in errors) {
        let details = errors[key];
        for (let i = 0; i < details.length; i++) {
            details[i] !== undefined && app.$bvToast.toast(details[i] || 'Se produjo un error.', {
                title: 'Error - ' + key,
                variant: 'danger',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
        }
    }

    return Promise.reject(error);
});
